/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { SortingState, IntegratedSorting } from '@devexpress/dx-react-grid';
import { 
  Grid, 
  TableHeaderRow, 
  VirtualTable,
  ColumnChooser,
  TableColumnVisibility,
  Toolbar
} from '@devexpress/dx-react-grid-material-ui';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';

const CellComponent = props => (
  <VirtualTable.Cell
    {...props}
    style={{
      padding: '5px',
      fontSize: '12px',
      lineHeight: '12px',
      borderRight: '1px solid #f1f1f1'
    }}
  />
);

const HeaderCellComponent = props => (
  <TableHeaderRow.Cell
    {...props}
    style={{
      padding: '5px',
      lineHeight: '15px',
      fontSize: '12px',
      backgroundColor: '#dedede',
      borderRight: '1px solid #ccc',
      textAlign: 'center'
    }}
  />
)

const NewTable = ({id, Session}) => {
  // console.log(index)
  const [tableColumns, setTableColumns] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [tableColumnExtensions, setTableColumnExtensions] = useState([]);
  const { data, config } = Session.RX_Report.withId(id);

  const setColumns = () => {
    const newColumns = config.browser.columns.map(item => ({
      name: item.field,
      title: item.label,
      type: item.type
    }));
    setTableColumns(newColumns);
    setTableColumnExtensions(newColumns.map(item => {
      return {
        columnName: item.name,
        wordWrapEnabled: true
      }
    }))
  };

  const setFields = newData => {
    const clonedData = _.cloneDeep(newData);
    const counts = config.browser.columns.filter(x => x.type === 'SUM');
    const newRow = {};
    counts.map(item => {
      const numbers = clonedData.map(x => {
          const field = x[item.field];
          if (field % 1 === 0) {
              return parseInt(field);
          }
          return 0
      })
      if (numbers && numbers.length > 0) {
        newRow[item.field] = `${numbers.reduce((acc, item) => acc + item)}`
      }
    });
    clonedData.unshift(newRow);
    setTableRows(clonedData);
  }

  const handleSearch = _.debounce(val => {
    if (!val) {
      setFields(data.rows)
    } else {
      const value = val.toUpperCase().split(' ');
      const filtered = data.rows.filter(item => value.every(x => item.backendSearchValue && item.backendSearchValue.indexOf(x) > -1));
      setFields(filtered);
    }
  }, 500);

  useEffect(() => {
    setColumns();
    setFields(data.rows);
  }, [data]);

  const Root = props => <Grid.Root {...props} style={{ height: '100%', backgroundColor: '#fff' }} />;

  return (
    <Paper style={{height: 'calc(100vh - 150px)', position: 'relative'}}>
      <div style={{ margin: '10px 20px', position: 'absolute', top: -9, width: 'calc(100% - 160px)' }}>
        <TextField label="Search" fullWidth onChange={e => handleSearch(e.target.value)} />
      </div>
      <Grid
        rows={tableRows}
        columns={tableColumns}
        rootComponent={Root}
      >
        <SortingState />
        <IntegratedSorting />
        <VirtualTable columnExtensions={tableColumnExtensions} cellComponent={CellComponent} />
        <TableHeaderRow showSortingControls cellComponent={HeaderCellComponent} />
        <TableColumnVisibility />
        <Toolbar />
        <ColumnChooser />
      </Grid>
    </Paper>
  );
}

export default NewTable;



// WEBPACK FOOTER //
// ./src/components/NewTable.js